// extracted by mini-css-extract-plugin
module.exports = {"list":"wkguL","actions":"T+r3y","buttonsGroup":"zDisE","buttons":"cC5vK","search":"_6U1zb","links":"_0CZ34","message":"YaavJ","loader":"UBZ0Q","dataGrid":"AnIUn","center":"LewLD"};